
import React from 'react'

// components
import {
  CRow,
  CCol,
  CFormLabel,
  CImage,
  CButton,
  CAccordion, 
  CAccordionBody, 
  CAccordionHeader, 
  CAccordionItem
} from '@coreui/react-pro'

import FormTextInput from './FormTextInput'
import FormPrice from './FormPrice'
import FormDatePicker from './FormDatePicker'
import FormTextAreaInput from './FormTextAreaInput'
import FormImageThumbnail from './FormImageThumbnail'
import FormFileUpload from './FormFileUpload'
import FormFileThumbnail from './FormFileThumbnail'

// icons
import AddMoreIconWhite from '../../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from 'src/components/custom-styles/buttonStyles'

// helpers
import { getFileType } from 'src/helpers/get-file-type'

const FormPurchaseOrder = ({
  colSize,
  inputLabel,
  className,
  purchase_orders,
  handleAddPurchaseOrder,
  errors,
  handleChange,
  handleRemovePurchaseOrder,
  isDetail,
  setOpenFilePreview,
  handleConfirmDelete
}) => {
  return (
    <CCol lg={colSize} className={className}>
      <div className='mb-3 d-grid gap-2 d-md-flex justify-content-between align-items-center'>
        <CFormLabel>
          {inputLabel}
        </CFormLabel>
        {
          !isDetail && (
            <CButton
              onClick={() => handleAddPurchaseOrder()}
              style={styleButtonVars2}
            >
              <CImage fluid src={AddMoreIconWhite} className='me-2' />
              {purchase_orders?.length > 0 ? 'Add More' : 'Add'}
            </CButton>
          )
        }
      </div>
      {purchase_orders?.length > 0 ? (
        purchase_orders?.map((inputField, index) => {
          let fileType = ''
          if (inputField.purchase_order_file?.length > 0) {
            if (inputField.purchase_order_file[0]?.name) {
              fileType = getFileType(inputField.purchase_order_file[0]?.name)
            } else if (inputField.purchase_order_file[0]?.file_original_name) {
              fileType = getFileType(inputField.purchase_order_file[0]?.file_original_name)
            } else {
              fileType = getFileType(inputField.purchase_order_file[0])
            }
          }
          return (
            <CAccordion>
              <CAccordionItem itemKey={index+1} className='mb-2'>
                <CAccordionHeader>Purchase Order {index + 1}</CAccordionHeader>
                <CAccordionBody>
                  <CRow className="mb-4">
                    <FormTextInput 
                      id='order_number'
                      name='order_number'
                      colSize='6'
                      className='mb-3'
                      inputLabel='Purchase Order No'
                      placeholder='Enter order number...'
                      value={inputField?.order_number}
                      handleTextInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_number}
                      invalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_number}
                      disabled={isDetail}
                    />
                    <FormDatePicker 
                      id='order_created'
                      name='order_created'
                      colSize='6'
                      inputLabel='Purchase Order Created On'
                      className='mb-3'
                      handleOnDateChange={(e) => handleChange(e, index)}
                      value={inputField?.order_created}
                      feedbackInvalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_created}
                      invalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_created}
                      disabled={isDetail}
                    />
                    <FormPrice
                      id='order_value'
                      name='order_value'
                      colSize='6'
                      inputLabel='Purchase Order Value'
                      placeholder='Enter order value...'
                      value={inputField?.order_value}
                      handlePriceInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_value}
                      invalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_value}
                      disabled={isDetail}
                    />
                    <FormTextAreaInput
                      id='order_notes'
                      name='order_notes'
                      colSize='6'
                      inputLabel='Notes'
                      className='mb-3'
                      placeholder='Enter notes...'
                      rows='6'
                      value={inputField?.order_notes}
                      handleTextAreaInput={(e) => handleChange(e, index)}
                      feedbackInvalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_notes}
                      invalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.order_notes}
                      disabled={isDetail}
                    />
                    {inputField?.purchase_order_file?.length > 0 ? fileType && fileType == 'image' ? (
                      <FormImageThumbnail
                        inputLabel='Attachment'
                        name='purchase_order_file'
                        colSize='6'
                        productImages={inputField?.purchase_order_file}
                        handleChangeImage={(e) => {
                          handleChange(e, index, 'purchase_order_file')
                        }}
                        handleRemoveImage={handleConfirmDelete}
                        setOpenFilePreview={setOpenFilePreview}
                      />
                    ) : (
                      <CCol lg={6}>
                        <CFormLabel>
                          Attachment
                        </CFormLabel>
                        <FormFileThumbnail 
                          name='purchase_order_file'
                          colSize='6'
                          files={inputField?.purchase_order_file}
                          className='justify-content-start align-items-center'
                          handleViewFile={setOpenFilePreview}
                          isDetailPage={isDetail}
                          handleConfirmDelete={handleConfirmDelete}
                          indexParent={index}
                        />
                      </CCol>
                    ) : (
                      <FormFileUpload
                        name='purchase_order_file'
                        colSize='6'
                        inputLabel='Attachment'
                        handleFileInput={(e) => {
                          handleChange(e, index, 'purchase_order_file')
                        }}
                        handleFileOnDrop={(e) => {
                          handleChange(e, index, 'purchase_order_file')
                        }}
                        multiple={false}
                        feedbackInvalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.purchase_order_file}
                        invalid={errors?.project_purchase_orders?.length > 0 && errors?.project_purchase_orders[index]?.purchase_order_file}
                        maxFiles={1}
                      />
                    )}
                  </CRow>
                  <CRow>
                    <CCol lg={1}>
                      {
                        purchase_orders?.length > 0 && !isDetail && (
                          <CButton
                            style={styleButtonVars2}
                            onClick={() => {handleRemovePurchaseOrder(inputField, index)}}
                          >
                            Delete
                          </CButton>
                        )
                      }
                    </CCol>
                  </CRow>
                </CAccordionBody>
              </CAccordionItem>
            </CAccordion>

          )
        })
      ) : !isDetail ? (
        <div className='alert alert-secondary'><b>You can add purchase order</b></div>
      ) : (
        <div className='alert alert-secondary'><b>You not have purchase order</b></div>
      )}
    </CCol>
  )
}

export default FormPurchaseOrder
